import React, { useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

const OtherMinerals = ({
  heading = "Other Mineral Products",
  minerals,
  currentMineralId,
  basePath,
  selectedMinerals = null
}) => {

  

  const prevRef = useRef(null);
  const nextRef = useRef(null);


  const navigate = useNavigate();

  const [selectedCard, setSelectedCard] =
    useState(null);

  /* =========================
     FILTER CURRENT MINERAL
  ========================= */

  const filteredMinerals = selectedMinerals
  ? minerals.filter((item) =>
      selectedMinerals.includes(item.id)
    )
  : minerals.filter(
      (item) => item.id !== currentMineralId
    );

    const showDesktopSlider =
  filteredMinerals.length > 3;

const showMobilePagination =
  filteredMinerals.length > 1;

  const hideDesktopPagination = filteredMinerals.length < 4;

  return (
    <section className="card-section other-minerals-section container">

     {/* HEADING */}
{heading && (
  <motion.h2
    className="section-heading"
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{
      duration: 0.8,
      ease: "easeOut"
    }}
    viewport={{ once: true }}
  >
    {heading}
  </motion.h2>
)}

      {/* SLIDER */}

      <div className="slider-container-wrapper">

        {/* ARROWS */}

      {showDesktopSlider && (
  <div
    ref={prevRef}
    className="custom-arrow prev-arrow"
  >
    <span>&#10094;</span>
  </div>
)}

{showDesktopSlider && (
  <div
    ref={nextRef}
    className="custom-arrow next-arrow"
  >
    <span>&#10095;</span>
  </div>
)}

        <Swiper
          modules={[Navigation, Pagination]}
          slidesPerView={3}
          spaceBetween={35}
          loop={filteredMinerals.length > 1}
          watchOverflow={true}
        navigation={
  showDesktopSlider
    ? {
        prevEl: prevRef.current,
        nextEl: nextRef.current,
      }
    : false
}
          onBeforeInit={(swiper) => {

            swiper.params.navigation.prevEl =
              prevRef.current;

            swiper.params.navigation.nextEl =
              nextRef.current;
          }}
        pagination={
  showMobilePagination
    ? {
        clickable: true,
        el: ".other-minerals-pagination",
      }
    : false
}
centeredSlides={
  filteredMinerals.length < 3 &&
  window.innerWidth > 992
}
centeredSlidesBounds={
  filteredMinerals.length < 3 &&
  window.innerWidth > 992
}
          breakpoints={{
            320: {
              slidesPerView: 1,
              spaceBetween: 15,
            },

            576: {
              slidesPerView: 1,
              spaceBetween: 20,
            },

            768: {
              slidesPerView: 2,
              spaceBetween: 25,
            },

           1024: {
  slidesPerView: 2,
  spaceBetween: 35,
},
      1400: {
  slidesPerView: 3,
  spaceBetween: 35,
},
      
          }}
        className={`other-minerals-slider ${
  filteredMinerals.length < 3
    ? "few-slides"
    : ""
}`}
        >

          {filteredMinerals.map((card) => (

            <SwiperSlide key={card.id}>

              <motion.div
                className="card"
                initial={{
                  opacity: 0,
                  y: 50
                }}
                whileInView={{
                  opacity: 1,
                  y: 0
                }}
                transition={{
                  duration: 0.7,
                  ease: "easeOut"
                }}
                viewport={{ once: true }}
                whileHover={{ y: -8 }}
                whileTap={{ scale: 0.98 }}
                onClick={() =>
                  setSelectedCard(card)
                }
              >

                <div className="card-content">

                  {/* IMAGE */}

                  <div className="image-wrapper">

                    <motion.img
                      src={card.img}
                      alt={`${card.cardDescription} | Iris Impulse India Pvt. Ltd.`}
                      className="card-image"
                      whileHover={{
                        scale: 1.05
                      }}
                      transition={{
                        duration: 0.5
                      }}
                    />

                  </div>

                  <h3>
                    {card.cardTitle}
                  </h3>

                  <p>
                    {card.cardDescription}
                  </p>

                </div>

              </motion.div>

            </SwiperSlide>
          ))}

        </Swiper>
      {showMobilePagination && (
  <div
    className={`other-minerals-pagination ${
      hideDesktopPagination ? "hide-desktop-pagination" : ""
    }`}
  ></div>
)}

      </div>

      {/* MODAL */}

      <AnimatePresence>

        {selectedCard && (

          <motion.div
            className="modal-overlay"
            onClick={() =>
              setSelectedCard(null)
            }
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          >

            <motion.div
              className="modal-content"
              onClick={(e) =>
                e.stopPropagation()
              }
              initial={{
                opacity: 0,
                scale: 0.9,
                y: 40
              }}
              animate={{
                opacity: 1,
                scale: 1,
                y: 0
              }}
              exit={{
                opacity: 0,
                scale: 0.9,
                y: 40
              }}
              transition={{
                duration: 0.4,
                ease: "easeOut"
              }}
            >

              {/* CLOSE */}

              <div className="modal-header">

                <button
                  className="modal-close"
                  onClick={(e) => {

                    e.stopPropagation();

                    setSelectedCard(null);
                  }}
                >
                  ×
                </button>

              </div>

              {/* CONTENT */}

              <img
                src={selectedCard.largeImg}
                alt={`${selectedCard.cardDescription} | Iris Impulse India Pvt. Ltd.`}
              />

              <h3>
                {selectedCard.cardTitle}
              </h3>

              <h4>
                {selectedCard.cardDescription}
              </h4>

              <p className="section-text">
                {selectedCard.introPara}
              </p>

              <motion.button
                className="outline-btn"
                whileHover={{
                  scale: 1.05
                }}
                whileTap={{
                  scale: 0.97
                }}
                onClick={() =>
                  navigate(
                    `${basePath}/${selectedCard.url}`
                  )
                }
              >
                LEARN MORE
              </motion.button>

            </motion.div>

          </motion.div>
        )}

      </AnimatePresence>

    </section>
  );
};

export default OtherMinerals;